import React, { useEffect, useState } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import * as A from "../../../css/Selling/Selling.style";
import { PersonalRequestForm } from "./CSellingRequestForm/PersonalRequestForm/PersonalRequestForm";
import { TradingRequestForm } from "./CSellingRequestForm/CoorporateRequestForm/Trading/TradingRequestForm";
import { useLocation, useNavigate } from "react-router-dom";
import { RentalRequestForm } from "./CSellingRequestForm/CoorporateRequestForm/Rental/RentalRequestForm";
import { LicenseRequestForm } from "./CSellingRequestForm/LicenseRequestForm/LicenseReuestForm";
import { scrollToTop } from "../../../utils/hooks/scrollToTop";

// 판매신청 공통 탭
const ShowRequestTab = ({
  activeTab,
  subActiveTab,
  buyingData,
  cSellingData,
  isEdit,
}) => {
  if (buyingData?.type === 2101) {
    // 개인 매매 (소형, 중형, 대형)
    return (
      <PersonalRequestForm
        subActiveTab={subActiveTab}
        buyingData={cSellingData}
        isEdit={isEdit}
      />
    );
  } else if (buyingData?.type === 2102) {
    // 법인 매매
    return (
      <TradingRequestForm
        subActiveTab={subActiveTab}
        buyingData={cSellingData}
        isEdit={isEdit}
      />
    );
  } else if (buyingData?.type === 2103) {
    // 법인 임대
    return (
      <RentalRequestForm
        subActiveTab={subActiveTab}
        buyingData={cSellingData}
        isEdit={isEdit}
      />
    );
  } else {
    return (
      <LicenseRequestForm
        subActiveTab={subActiveTab}
        buyingData={cSellingData}
        isEdit={isEdit}
      />
    );
  }
};

function CSellingRequestTab() {
  const [activeTab, setActiveTab] = useState(1);
  const [subActiveTab, setSubActiveTab] = useState("first");
  const [cSellingData, setCSellingData] = useState({
    corp_nm: "",
    car_weight_nm: "",
    car_weight: "",
    car_yyyymm: null,
    price: 0,
    process_cd: 0,
    reg_dt: "",
    region_nm: "",
    buy_seq: -1,
    target_seq: -1,
  });

  const tabShow = (id) => {
    setActiveTab(id);
    setSubActiveTab("first"); // Reset subActiveTab when changing the main tab
  };
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    scrollToTop();
    if (location?.state?.data) {
      setCSellingData(location.state.data);
    } else {
      navigate(-1);
    }
  }, []);


  if (cSellingData.target_seq === -1) {
    return <div>로딩 중...</div>; // 또는 null로 아무것도 렌더링하지 않을 수도 있음
  }

  return (
    <>
      <ShowRequestTab
        activeTab={activeTab}
        subActiveTab={subActiveTab}
        setSubActiveTab={setSubActiveTab}
        cSellingData={cSellingData}
        buyingData={location?.state?.data}
        isEdit={location?.state?.isEdit}
      />
    </>
  );
}

export default CSellingRequestTab;
